import app from 'flarum/common/app';
import { KeyValueGambit } from 'flarum/common/query/IGambit';
export default class TagGambit extends KeyValueGambit {
  predicates = true;
  key() {
    return app.translator.trans('nightash-labels.lib.gambits.discussions.tag.key', {}, true);
  }
  hint() {
    return app.translator.trans('nightash-labels.lib.gambits.discussions.tag.hint', {}, true);
  }
  filterKey() {
    return 'tag';
  }
  gambitValueToFilterValue(value) {
    return [value];
  }
  fromFilter(value, negate) {
    let gambits = [];
    if (Array.isArray(value)) {
      gambits = value.map(value => this.fromFilter(value.toString(), negate));
    } else {
      return `${negate ? '-' : ''}${this.key()}:${this.filterValueToGambitValue(value)}`;
    }
    return gambits.join(' ');
  }
  filterValueToGambitValue(value) {
    return value;
  }
}
flarum.reg.add('nightash-labels', 'common/query/discussions/TagGambit', TagGambit);